import {Injectable} from '@angular/core';
import {NEVER, Observable} from 'rxjs';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {GlobalSettingsService} from '../services/ui/global-settings.service';
import {catchError, tap} from 'rxjs/operators';
import {JobProcedureService} from '../services/sections/job/job-procedure.service';
import { JobProcedureFormValidationsSkipRequestDetails } from '../models/jobProcedureFormValidationsSkipRequestDetails';

@Injectable({providedIn: 'root'})
export class ProcedureFormValidationsSkipResolver implements Resolve<Observable<JobProcedureFormValidationsSkipRequestDetails>>{
	constructor(
		private router: Router,
		private jobProcedureService: JobProcedureService
	) {}
	resolve(route: ActivatedRouteSnapshot): Observable<JobProcedureFormValidationsSkipRequestDetails> {
		GlobalSettingsService.isSecondaryLoaderLoading = true;

	return this.jobProcedureService
		.getJobValidationsSkipRequiredRequest(route.paramMap.get('token'))
		.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				}),
				tap((result) => {
					GlobalSettingsService.preferencesPayloadForJobDetails.jobProcedureFormValidationsSkipRequestDetails = result;
				}),
		);
	}
}
